module.exports = __webpack_public_path__ + "img/HQ-PA10W1L-T.85d0e6ae.jpg";